import { LayerDefinition } from './types';

export const relativeHumidityDefinition: LayerDefinition = {
  id: 'relative_humidity',
  name: 'Relative Humidity',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '💧',
  description: '2m Surface Relative Humidity percentage.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'icon13'],
  outputModels: ['Surface RH .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default relativeHumidityDefinition;
